import Vue from 'vue';
import VueRouter from 'vue-router';
import { authStore } from '@/store/authStore';
import { appStore } from '@/store/appStore';
import { i18n } from '@/i18n';

Vue.use(VueRouter);

const LoadingPage = () => import(/* webpackChunkName: "loading" */ '../views/lanhu_1jiazaiye/index.vue');
const LoginPage = () => import(/* webpackChunkName: "auth" */ '../views/lanhu_21shoujiyanzhengmadenglu/index.vue');
const ActivatePage = () => import(/* webpackChunkName: "auth" */ '../views/lanhu_3jihuo/index.vue');
const HomePage = () => import(/* webpackChunkName: "home" */ '../views/lanhu_4shouye/index.vue');
const DivinationPage = () => import(/* webpackChunkName: "divination" */ '../views/lanhu_5qiguayemian/index.vue');
const HexagramPage = () => import(/* webpackChunkName: "divination" */ '../views/lanhu_6guaxiangjiedu/index.vue');
const QuestionPage = () => import(/* webpackChunkName: "consult" */ '../views/lanhu_71wentixinxi/index.vue');
const ConsultConfigPage = () => import(/* webpackChunkName: "consult" */ '../views/lanhu_74xuanzezhinengti/index.vue');
const ProfilesPage = () => import(/* webpackChunkName: "profile" */ '../views/lanhu_82danganer/index.vue');
const ProfileEditPage = () => import(/* webpackChunkName: "profile" */ '../views/lanhu_83bianjidangan/index.vue');
const ProfileDetailPage = () => import(/* webpackChunkName: "profile" */ '../views/lanhu_85danganxiangqing/index.vue');
const AccountPage = () => import(/* webpackChunkName: "account" */ '../views/lanhu_9gerenzhongxin/index.vue');
const ResultsPage = () => import(/* webpackChunkName: "results" */ '../views/lanhu_10jieguoliebiao/index.vue');
const ResultDetailPage = () => import(/* webpackChunkName: "results" */ '../views/lanhu_11jieguoxiangqingye/index.vue');
const SharePage = () => import(/* webpackChunkName: "share" */ '../views/lanhu_12fenxianghaibao/index.vue');
const AgentShowcaseBaziPage = () => import(/* webpackChunkName: "showcase" */ '../views/lanhu_131zhinengtifengmian/index.vue');
const AgentShowcaseDreamPage = () => import(/* webpackChunkName: "showcase" */ '../views/lanhu_132zhinengtifengmian/index.vue');
const AgentShowcaseCareerPage = () => import(/* webpackChunkName: "showcase" */ '../views/lanhu_133zhinengtifengmian/index.vue');
const AgentShowcaseSignPage = () => import(/* webpackChunkName: "showcase" */ '../views/lanhu_134zhinengtifengmian/index.vue');
const AgentShowcaseReliefPage = () => import(/* webpackChunkName: "showcase" */ '../views/lanhu_135zhinengtifengmian/index.vue');
const TutorialPage = () => import(/* webpackChunkName: "tutorial" */ '../views/lanhu_14shiyongzhinan/index.vue');
const InternalActivationCodeGeneratorPage = () => import(/* webpackChunkName: "internal-tools" */ '../views/internal_activation_code_generator/index.vue');

const routes = [
  {
    path: '/',
    redirect: '/loading'
  },
  {
    path: '/loading',
    name: 'loading',
    component: LoadingPage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/activate',
    name: 'activate',
    component: ActivatePage
  },
  {
    path: '/home',
    name: 'home',
    component: HomePage
  },
  {
    path: '/divination',
    name: 'divination',
    component: DivinationPage
  },
  {
    path: '/hexagram',
    name: 'hexagram',
    component: HexagramPage
  },
  {
    path: '/question',
    name: 'question',
    component: QuestionPage
  },
  {
    path: '/consult-config',
    name: 'consult-config',
    component: ConsultConfigPage
  },
  {
    path: '/profiles',
    name: 'profiles',
    component: ProfilesPage
  },
  {
    path: '/profile-edit',
    name: 'profile-edit',
    component: ProfileEditPage
  },
  {
    path: '/profile-detail',
    name: 'profile-detail',
    component: ProfileDetailPage
  },
  {
    path: '/account',
    name: 'account',
    component: AccountPage
  },
  {
    path: '/results',
    name: 'results',
    component: ResultsPage
  },
  {
    path: '/result-detail',
    name: 'result-detail',
    component: ResultDetailPage
  },
  {
    path: '/share',
    name: 'share',
    component: SharePage
  },
  {
    path: '/agent-showcase/bazi',
    name: 'agent-showcase-bazi',
    component: AgentShowcaseBaziPage
  },
  {
    path: '/agent-showcase/dream',
    name: 'agent-showcase-dream',
    component: AgentShowcaseDreamPage
  },
  {
    path: '/agent-showcase/career',
    name: 'agent-showcase-career',
    component: AgentShowcaseCareerPage
  },
  {
    path: '/agent-showcase/sign',
    name: 'agent-showcase-sign',
    component: AgentShowcaseSignPage
  },
  {
    path: '/agent-showcase/relief',
    name: 'agent-showcase-relief',
    component: AgentShowcaseReliefPage
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: TutorialPage
  },
  {
    path: '/internal/activation-code-generator',
    name: 'internal-activation-code-generator',
    component: InternalActivationCodeGeneratorPage
  },
  {
    path: '/lanhu_1jiazaiye',
    redirect: '/loading'
  },
  {
    path: '/lanhu_21shoujiyanzhengmadenglu',
    redirect: {
      path: '/login',
      query: {
        mode: 'mobile'
      }
    }
  },
  {
    path: '/lanhu_22youxiangyanzhengmadenglu',
    redirect: {
      path: '/login',
      query: {
        mode: 'email'
      }
    }
  },
  {
    path: '/lanhu_3jihuo',
    redirect: '/activate'
  },
  {
    path: '/lanhu_4shouye',
    redirect: '/home'
  },
  {
    path: '/lanhu_5qiguayemian',
    redirect: '/divination'
  },
  {
    path: '/lanhu_6guaxiangjiedu',
    redirect: '/hexagram'
  },
  {
    path: '/lanhu_71wentixinxi',
    redirect: {
      path: '/question',
      query: {
        step: '1'
      }
    }
  },
  {
    path: '/lanhu_72wentixinxi',
    redirect: {
      path: '/question',
      query: {
        step: '2'
      }
    }
  },
  {
    path: '/lanhu_73wentixinxi',
    redirect: {
      path: '/question',
      query: {
        step: '3'
      }
    }
  },
  {
    path: '/lanhu_74xuanzezhinengti',
    redirect: '/consult-config'
  },
  {
    path: '/lanhu_81danganyi',
    redirect: '/profiles'
  },
  {
    path: '/lanhu_82danganer',
    redirect: '/profiles'
  },
  {
    path: '/lanhu_83bianjidangan',
    redirect: '/profile-edit'
  },
  {
    path: '/lanhu_84gonglinonglixuanze',
    redirect: {
      path: '/profile-edit',
      query: {
        calendar: '1'
      }
    }
  },
  {
    path: '/lanhu_85danganxiangqing',
    redirect: '/profile-detail'
  },
  {
    path: '/lanhu_9gerenzhongxin',
    redirect: '/account'
  },
  {
    path: '/lanhu_10jieguoliebiao',
    redirect: '/results'
  },
  {
    path: '/lanhu_11jieguoxiangqingye',
    redirect: '/result-detail'
  },
  {
    path: '/lanhu_12fenxianghaibao',
    redirect: '/share'
  },
  {
    path: '/lanhu_131zhinengtifengmian',
    redirect: '/agent-showcase/bazi'
  },
  {
    path: '/lanhu_132zhinengtifengmian',
    redirect: '/agent-showcase/dream'
  },
  {
    path: '/lanhu_133zhinengtifengmian',
    redirect: '/agent-showcase/career'
  },
  {
    path: '/lanhu_134zhinengtifengmian',
    redirect: '/agent-showcase/sign'
  },
  {
    path: '/lanhu_135zhinengtifengmian',
    redirect: '/agent-showcase/relief'
  },
  {
    path: '/lanhu_14shiyongzhinan',
    redirect: '/tutorial'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const publicPaths = new Set(['/loading', '/login', '/share', '/internal/activation-code-generator']);

router.beforeEach((to, from, next) => {
  document.title = i18n.t('app.title');
  const isLoggedIn = authStore.isAuthenticated();
  const isActivated = authStore.state.isActivated;

  if (to.path === '/loading') {
    next();
    return;
  }

  if (to.path === '/login') {
    if (isLoggedIn && !isActivated) {
      next({
        path: '/activate',
        query: {
          forced: '1'
        }
      });
      return;
    }
    if (isLoggedIn && isActivated) {
      next(appStore.state.redirectAfterActivate || '/home');
      return;
    }
    next();
    return;
  }

  if (publicPaths.has(to.path)) {
    next();
    return;
  }

  if (!isLoggedIn) {
    appStore.setRedirectAfterLogin(to.fullPath);
    next({
      path: '/login',
      query: {
        forced: '1'
      }
    });
    return;
  }

  if (isLoggedIn && !isActivated && to.path !== '/activate') {
    appStore.setRedirectAfterActivate(to.fullPath || from.fullPath || '/home');
    next({
      path: '/activate',
      query: {
        forced: '1'
      }
    });
    return;
  }

  if (to.path === '/activate' && isLoggedIn && isActivated) {
    next(appStore.state.redirectAfterActivate || '/home');
    return;
  }

  next();
});

export default router;
